import router from '@/router/dashboard';
import store from '@/store/index';
import DashboardApp from './DashboardSwitch.vue';
import SmartTable from '@/components/Table/main';
import Vue from 'vue';
import auth from '@/utils/auth';
import helpers from '@/utils/helpers';

Vue.use(auth);
Vue.use(SmartTable);
Vue.use(helpers);
Vue.config.productionTip = false;

export const Dashboard = new Vue({
  router,
  store,
  render: h => h(DashboardApp),
}).$mount('#app');
